import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const MostWantedLanguages: React.FC = () => {
  const data = [
    {
      language: 'JavaScript',
      value: 22.319474835886215,
      fill: '#08306B'
    },
    { language: 'Python', value: 17.067833698030636, fill: '#08306B' },
    { language: 'JAVA', value: 15.75492341356674, fill: '#08519C' },
    { language: 'PHP', value: 10.50328227571116, fill: '#08519C' },
    { language: 'TypeScript', value: 7.439824945295405, fill: '#2171B5' },
    { language: 'Kotlin', value: 4.595185995623632, fill: '#2171B5' },
    { language: 'C#', value: 3.7199124726477026, fill: '#4292C6' },
    { language: 'C++', value: 2.62582056892779, fill: '#4292C6' },
    { language: 'Go', value: 2.62582056892779, fill: '#6BAED6' },
    { language: 'Ruby', value: 2.1881838074398248, fill: '#6BAED6' }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 40]}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default MostWantedLanguages;
